"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeContentProcessorResult = exports.encodeContentProcessorDTO = exports.decodeContentProcessorDTO = void 0;
const t = __importStar(require("io-ts"));
const io_ts_types_1 = require("io-ts-types");
const codecs_1 = require("../codecs");
const ContentProcessorResult = t.exact(t.type({
    publish_date: (0, io_ts_types_1.optionFromNullable)(io_ts_types_1.DateFromISOString),
    company_name: (0, io_ts_types_1.optionFromNullable)(t.string),
    domain: (0, io_ts_types_1.optionFromNullable)(t.string),
    sentiment: (0, io_ts_types_1.optionFromNullable)(t.string),
    language: (0, io_ts_types_1.optionFromNullable)(t.string),
    keywords: (0, io_ts_types_1.optionFromNullable)(t.array(t.string)),
    key_people: (0, io_ts_types_1.optionFromNullable)(t.array(t.string)),
    is_raising_capital: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_ipo: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_merger: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_moving: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_hiring: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_firing: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_closing: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_opening: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_expanding: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_downsizing: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_restructuring: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_new_product_intro: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    has_moved: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_moving_to_new_office: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    has_moved_to_new_office: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_changing_ceo: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_changing_board: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_changing_management_team: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_growth_geog: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_growth_seg: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_pricing_model: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_partnership: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_m_and_a: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_divest: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_cost_save: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_restruct: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_layoff: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_hire_plan: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_leadership: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_capex_scale: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_supply_chain: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_digi_ai: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_esg_target: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_esg_event: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_reg_change: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_litigation: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_fin_raise: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_div_policy: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_rev_guide: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_rev_mix: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_cust_mega: (0, io_ts_types_1.optionFromNullable)(t.boolean),
    is_risk_macro: (0, io_ts_types_1.optionFromNullable)(t.boolean),
}));
const ContentProcessor = t.exact(t.intersection([
    t.type({
        timestamp: io_ts_types_1.DateFromISOString,
        source_url: t.string,
        orgnr: (0, io_ts_types_1.optionFromNullable)(t.string),
        result: ContentProcessorResult,
        post_title: (0, io_ts_types_1.optionFromNullable)(t.string),
        correlation_id: io_ts_types_1.UUID,
        market: codecs_1.ISO3166Codec,
    }),
    t.partial({
        source_name: (0, io_ts_types_1.optionFromNullable)(t.string),
    }),
]));
const decodeContentProcessorDTO = (input) => ContentProcessor.decode(input);
exports.decodeContentProcessorDTO = decodeContentProcessorDTO;
const encodeContentProcessorDTO = (input) => ContentProcessor.encode(input);
exports.encodeContentProcessorDTO = encodeContentProcessorDTO;
const decodeContentProcessorResult = (input) => ContentProcessorResult.decode(input);
exports.decodeContentProcessorResult = decodeContentProcessorResult;
//# sourceMappingURL=content-processor-result.js.map